"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactScroll = require("react-scroll");

var _reactIndianaDragScroll = _interopRequireDefault(require("react-indiana-drag-scroll"));

var _Tabs = require("./Tabs.styles");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabsHeaderContent = function TabsHeaderContent(_ref) {
  var headers = _ref.headers,
      onHeaderClick = _ref.onHeaderClick,
      currentTab = _ref.currentTab,
      handleCurrentTabChange = _ref.handleCurrentTabChange,
      containerId = _ref.containerId,
      id = _ref.id;
  (0, _react.useEffect)(function () {
    _reactScroll.scrollSpy.update();

    handleCurrentTabChange(0)();
  }, [headers]);
  return (0, _core.jsx)("div", {
    css: _Tabs.tabHeaderWrapper,
    id: id
  }, (0, _core.jsx)(_reactIndianaDragScroll["default"], {
    css: _Tabs.tabsHeaders
  }, headers.map(function (title, headerIndex) {
    return (0, _core.jsx)(_reactScroll.Link, {
      key: title,
      activeClass: "active",
      to: "tab-".concat(headerIndex),
      smooth: true,
      spy: true,
      offset: -50,
      duration: 500,
      isDynamic: true,
      containerId: containerId,
      onSetActive: handleCurrentTabChange(headerIndex)
    }, (0, _core.jsx)(_Tabs.TabHeader, {
      onClick: onHeaderClick(headerIndex),
      active: headerIndex === currentTab
    }, title));
  })));
};

TabsHeaderContent.defaultProps = {
  containerId: undefined,
  id: 'tabs__header'
};
TabsHeaderContent.propTypes = {
  headers: _propTypes["default"].array.isRequired,
  onHeaderClick: _propTypes["default"].func.isRequired,
  currentTab: _propTypes["default"].number.isRequired,
  handleCurrentTabChange: _propTypes["default"].func.isRequired,
  containerId: _propTypes["default"].string,
  id: _propTypes["default"].string
};
var _default = TabsHeaderContent;
exports["default"] = _default;

//# sourceMappingURL=TabsHeader.js.map